document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-split-decanter', () => {
      // Block has static behavior; hook keeps preview lifecycle aligned.
    });
  }
});
